var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.78e90e191a1ef11cb3352595f66683b9.svg#s';
                    var viewUrl = 'sprites.78e90e191a1ef11cb3352595f66683b9.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 104 36',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };